module.exports = __webpack_public_path__ + "img/painPerceptionScale_4_w.ab1cfbfc.png";